<template>
  <el-row class="c-grid-item">
    <el-col v-for="(item,index) in gridItems" :key="index" :span="item.span||cGrid.span">
      <template>
        <div class="c-grid-item-bord">
          <span :class="item.labelClass">{{item.label}}</span><span :class="item.valueClass">{{cGrid.value[item.model]}}</span>
        </div>
      </template>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      gridItems: Array
    },
    inject: ["cGrid"]
  }
</script>

<style>
  .c-grid-item .c-grid-item-bord {
    display: flex;
    align-items: center;
  }

  .c-grid-item .c-grid-item-bord span:first-child {
    text-align: center;
    display: inline-block;
    color: #787878;
  }

  .c-grid-item .c-grid-item-bord span:nth-child(2) {
    flex: 1;
    color: #1e1e1e;
    margin-left: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .c-grid-item .c-grid-item-bord .info-label{
    width: 100px;
  }
</style>
